module.exports = __webpack_public_path__ + "static/media/doortittle1.de806475.jpeg";